<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>
<template>
    <v-dialog v-model="openDialog" max-width="600px">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center">
                新規作成
            </v-card-title>
            <validation-observer ref="obs" v-slot="{ invalid }">
                <validation-provider
                      v-slot="{ errors }"
                      name="作成するグループ"
                      rules="required"
                    >
                    <v-card-title class="justify-center">
                        <v-select
                            placeholder="作成するグループを選択してください"
                            v-model="selectedOrganizationId"
                            :items="organizations"
                            :error-messages="errors"
                            outlined
                            background-color="white"
                        ></v-select>
                    </v-card-title>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="名前"
                  rules="required"
                >
                    <v-card-title class="justify-center">
                        <v-text-field width="30%" outlined clearable v-disabled-icon-focus v-model="nameText" placeholder="名前を入力してください" :error-messages="errors" :counter="255" background-color="white"></v-text-field>
                    </v-card-title>
                </validation-provider>
                <v-card-actions class="justify-center">
                    <v-btn width="30%" class="white--text mb-8" color="red" x-large @click="pushOk" :disabled="invalid">
                        作成
                    </v-btn>
                    <v-btn width="30%" class="white--text mb-8 ml-8" color="blue-grey darken-1" x-large @click="openDialog = false">
                        キャンセル
                    </v-btn>
                </v-card-actions>
            </validation-observer>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
            organizations: [],
            selectedOrganizationId: null,
            nameText: null,
        }
    },
    props: {
        dialog: Boolean,
    },
    created() {
        // キャビネット一覧を取得
        axios.get('/documents/document-management/get-create-cabinet-organizations').then(res => {
            this.organizations = res.data.organizations;
        });
    },
    computed: {
        openDialog: {
            get() {
                return this.dialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:dialog', value);
            }
        },
    },
    methods: {
        pushOk() {
            this.openDialog = false;
            this.$emit('clickOk', this.selectedOrganizationId, this.nameText);
        },
    },
}
</script>